import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { useAuth } from 'react-oidc-context';

/* eslint-disable-next-line */
export interface LoginProps {}

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15%',
  },
}));

export const Login: React.FC<LoginProps> = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const auth = useAuth();

  return (
    <div className={classes.container}>
      <Button
        data-test-id="login-button"
        onClick={() => void auth.signinRedirect()}
        variant="contained"
        color="primary"
      >
        Continue with JUMP
      </Button>
    </div>
  );
};

export default Login;
